// removed by extract-text-webpack-plugin
module.exports = {"warp":"_-pages-MessagePush-compontents-MessagePanel-warp","content":"_-pages-MessagePush-compontents-MessagePanel-content","title":"_-pages-MessagePush-compontents-MessagePanel-title","empty":"_-pages-MessagePush-compontents-MessagePanel-empty","emptyIcon":"_-pages-MessagePush-compontents-MessagePanel-emptyIcon"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/MessagePush/compontents/MessagePanel/index.css
// module id = 1873
// module chunks = 0